import { Table, Typography } from 'antd';
import { COLOR_OPTIONS } from 'config/style';
import styled from 'styled-components';

export const InfoContainer = styled.div``;

export const CropTable = styled(Table)`
  &.ant-table-wrapper {
    margin-bottom: 16px;

    .ant-table-thead > tr > th {
      background-color: #f3f4f6;
      font-weight: 600;
      font-size: 10.5px;
      padding: 12px;
      text-align: center;
      line-height: 15px;
      letter-spacing: -0.079px;
    }

    .ant-table-tbody > tr > td {
      padding: 12px;
      font-size: 10.5px;
      text-overflow: ellipsis;
      line-height: 15px;
      letter-spacing: -0.079px;
    }
  }
` as typeof Table;

export const Paragraph = styled(Typography.Paragraph)`
  font-size: 12px;
  color: ${COLOR_OPTIONS.NEUTRAL_80};
  line-height: 20px;
  letter-spacing: -0.09px;
`;
